import React from "react";
import "./CTProductCard.scss";
import rightArrow from "../../assets/images/nav-arrow-right.svg";
import { MotifAvatar, MotifButton } from "@ey-xd/motif-react";
import { useNavigate } from "react-router";
import CTAssignProxy from "../CTAssignProxy";

interface Owner {
  Name: string;
  Email: string;
}

interface CTProductCardProps {
  ProductId: string;
  Name: string;
  Description: string;
  ProxyOwner: Owner[];
  ProductOwner: Owner[];
  handleUpdateProxyOwners: (
    productId: string,
    proxyOwnersList: { Name: string; Email: string }[]
  ) => void;
  userEmail: string;
}

const CTProductCard: React.FC<CTProductCardProps> = ({
  ProductId,
  Name,
  Description,
  ProxyOwner,
  ProductOwner,
  handleUpdateProxyOwners,
  userEmail,
}) => {
  const navigate = useNavigate();

  const [assignProxy, setAssignProxy] = React.useState(false);

  const handleProxyOwnerClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setAssignProxy(true);
  };

  const handleCardClick = () => {
    navigate("/ct/product/" + ProductId + "/product-cost-setup");
  };

  const handleAssignProxyClose = () => {
    setAssignProxy(false);
    document.body.style.overflow = "";
  };

  const handleAssignProxy = (proxyOwnersList: Owner[]) => {
    setAssignProxy(false);
    document.body.style.overflow = "";
    handleUpdateProxyOwners(
      ProductId,
      proxyOwnersList.map((owner) => {
        return { Name: owner.Name, Email: owner.Email };
      })
    );
  };

  const handlePreview = (productId: string) => (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate("/ct/product/" + productId + "/preview");
  };

  const getProxyOwner = () => {
    if (
      ProductOwner.length > 0 &&
      ProductOwner.filter(
        (productOwner) =>
          productOwner.Email.toLowerCase() === userEmail.toLowerCase()
      ).length > 0
    ) {
      if (ProxyOwner.length > 0) {
        return (
          <MotifButton
            className="ct-product-card-btn-assign"
            onClick={handleProxyOwnerClick}
          >
            <span className="ct-product-card-avatars">
              <span>
                <MotifAvatar
                  description={ProxyOwner[0].Name + " " + ProxyOwner[0].Email}
                  userName={ProxyOwner[0].Name}
                />
              </span>
              {ProxyOwner.length > 1 && (
                <span className="ct-product-card-avatars-extra">
                  +{ProxyOwner.length - 1}
                </span>
              )}
            </span>

            <span className="pad-r-10 font-12">Edit Proxy Owner</span>
            <img src={rightArrow} alt="Edit Proxy Owner" />
          </MotifButton>
        );
      }
      return (
        <MotifButton
          className="ct-product-card-btn-assign"
          onClick={handleProxyOwnerClick}
        >
          <span className="pad-r-10">Assign Proxy Owner</span>
          <img src={rightArrow} alt="Assign Proxy Owner" />
        </MotifButton>
      );
    } else {
      return <></>;
    }
  };

  return (
    <>
      <div className="ct-product-card" onClick={handleCardClick}>
        <h3 className="ct-product-card-title">{Name}</h3>
        <div className="ct-product-card-body">
          <div className="ct-product-card-updated">
            <>Empire ID- {ProductId}</>
          </div>
          <div className="ct-product-card-description">{Description}</div>
        </div>
        <div className="ct-product-card-footer">
          <MotifButton
            variant="secondary"
            className="ct-product-card-btn-preview"
            onClick={handlePreview(ProductId)}
          >
            Preview &gt;
          </MotifButton>
          {getProxyOwner()}
        </div>
      </div>
      {assignProxy && (
        <CTAssignProxy
          onClose={handleAssignProxyClose}
          proxyOwners={ProxyOwner}
          show={assignProxy}
          onAssign={handleAssignProxy}
        />
      )}
    </>
  );
};

export default CTProductCard;
